/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import React, {ForwardedRef, forwardRef, useImperativeHandle, useState} from 'react';
import {ActivateHandle} from "../../../util/interfaces";
import {submitNotificationFeedback} from "../../../util/requestSender";
import {ResponseData, showDialog, showSnackbar} from '@dvrd/dvr-controls';
import {createErrorMessage} from "../../../util/utils";
import NotificationFeedback from "./notificationFeedback";

function NotificationFeedbackController(_: {}, ref: ForwardedRef<ActivateHandle>) {
    const [feedback, setFeedback] = useState('');
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    function onOpen() {
        setOpen(true);
    }

    function onClose() {
        setOpen(false);
        window.setTimeout(() => {
            setFeedback('');
            setLoading(false);
        });
    }

    function onChangeFeedback(value: string) {
        setFeedback(value);
    }

    function onSubmit() {
        if (!feedback.length) return;
        setLoading(true);
        submitNotificationFeedback({
            data: {feedback}, callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    onClose();
                    showSnackbar('Bedankt voor de feedback!');
                } else showDialog(createErrorMessage(data.message ?? 'Het verzenden van de feedback is niet gelukt.'),
                    'Verzenden mislukt');
            }
        });
    }

    useImperativeHandle(ref, () => ({activate: onOpen}));

    return (
        <NotificationFeedback onClose={onClose} onChangeFeedback={onChangeFeedback} onSubmit={onSubmit}
                              feedback={feedback} loading={loading} open={open}/>
    );
}

export default forwardRef<ActivateHandle, {}>(NotificationFeedbackController);